import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import useHook from '@/components/CustomerAreaCascader/useHook'
// import CustomerAreaCascader from '@/components/CustomerAreaCascader/CustomerKeyData.vue'
import type { ClueReceiveListItem } from '@/typings/api/marketingManage'
import { clueReceiveAdd, clueReceiveEdit } from '@/api/marketing/marketingManage'

const __default__ = { name: 'ClueReceiveAddModel' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const editForm = ref<ClueReceiveListItem>({})
const emit = __emit
const { customerAreaEnum } = useHook('cos_fbu', '815717')
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    let fun = clueReceiveAdd
    if (editForm.value.id) {
      fun = clueReceiveEdit
    }
    fun(editForm.value)
      .then(() => {
        visible.value = false
        emit('success')
        if (editForm.value.id) {
          DcMessage.success('分配区域成功')
        } else {
          DcMessage.success('新增成功')
        }
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const toggle = (rows?: ClueReceiveListItem) => {
  editForm.value = {
    ...rows
  }
  visible.value = true
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_tree_select = _resolveComponent("a-tree-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    title: editForm.value.id ? '分配区域' : '新增',
    class: "clueMerge",
    width: "670px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: editForm.value,
            ref_key: "formRef",
            ref: formRef
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "employeeNo",
                label: "员工",
                rules: [{ required: true, message: '请选择' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_UserSelect, {
                    disabled: editForm.value.id ? true : false,
                    value: editForm.value.employeeNo,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.employeeNo) = $event)),
                    placeholder: "请选择",
                    allowClear: ""
                  }, null, 8, ["disabled", "value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "areaId",
                label: "分配区域",
                rules: [{ required: true, message: '请选择' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tree_select, {
                    value: editForm.value.areaId,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((editForm.value.areaId) = $event)),
                    "show-search": "",
                    style: {"width":"100%"},
                    "dropdown-style": { maxHeight: '400px', overflow: 'auto' },
                    placeholder: "请选择",
                    "allow-clear": "",
                    multiple: "",
                    "tree-data": _unref(customerAreaEnum),
                    "tree-node-filter-prop": "label",
                    fieldNames: {children:'children', label:'label', value: 'id' }
                  }, null, 8, ["value", "tree-data"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title", "confirmLoading"]))
}
}

})